import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import { AbstractChatClient } from 'shared/clients/abstractChatClient';
import {
  type ConversationMetadata,
  type DataPayload,
} from 'types/customEventData';
import { type ZendeskSettings } from 'types/zendeskWidget';

export class ZopimChatClient extends AbstractChatClient {
  /**
   * The classic widget only takes tags. It has no equivalent for ticket
   * custom fields, so `conversationFields` is ignored here.
   */
  setConversationMetadata({ tags }: ConversationMetadata) {
    if (tags?.length) {
      window.zE?.('webWidget', 'chat:addTags', tags);
    }
  }

  identify(rawVisitorInfo?: DataPayload['visitor_info']): void {
    const visitorInfo = pickBy(rawVisitorInfo);

    if (!isEmpty(visitorInfo)) {
      window.zE?.('webWidget', 'identify', visitorInfo);
    }
  }

  showWidget(): void {
    window.zE?.('webWidget', 'show');
  }

  hideWidget(): void {
    window.zE?.('webWidget', 'hide');
  }

  openWidget(): void {
    window.zE?.('webWidget', 'open');
  }

  logout(): void {
    window.zE?.('webWidget', 'logout');
  }

  updateSettings(settings: ZendeskSettings['webWidget']) {
    if (!isEmpty(settings)) {
      window.zE?.('webWidget', 'updateSettings', settings);
    }
  }

  onChatEnd(callback: () => void) {
    window.zE?.('webWidget:on', 'chat:end', callback);
  }
}
